export default {
  namespaced: true,
  state: {
    messages: [],
  },
  getters: {
    all(state) {
      return state.messages
    },
  },
  mutations: {
    addMsg(state, {type, message}) {
      let msg = {
        type: type,
        message: message,
        key: 'message-handler' + Date.now(),
      }
      state.messages.push(msg)
    },
    delMsg(state, key) {
      state.messages = state.messages.filter(e => e.key !== key)
    },
  },
  actions: {},
  modules: {},
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/msg.js